import { config } from '@/app/config';

import { api } from './client';
import { endpoints } from './endpoints';

/** A student's shared portfolio page. Public: no token is needed. */
export function getPublicPortfolio(slug) {
  return api.get(endpoints.portfolio.bySlug(slug));
}

/**
 * Where the "Download CV" link points. The API answers with a redirect to a
 * short-lived signed URL, so a plain link works and nothing signed is kept in
 * the page.
 */
export function publicCvUrl(slug) {
  const base = new URL(config.apiBaseUrl, window.location.origin).toString().replace(/\/$/, '');
  return `${base}${endpoints.portfolio.cv(slug)}`;
}
